// extracted by mini-css-extract-plugin
module.exports = {"container":"Input-module--container--y-kIk","large":"Input-module--large--3gvka"};